'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'swatchbook';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f5c3';
var svgPathData = 'M0 400c0 61.9 50.1 112 112 112l400 0 0-224-58.2 0-48 48 58.2 0 0 128-254.1 0 255-255 17-17-17-17-128-128-17-17c-9 9-25 25-48 48L272 145.9 320 97.9 414.1 192 224 382.1 224 0 0 0 0 400zm112 64c-35.3 0-64-28.7-64-64l0-96 128 0 0 96c0 35.3-28.7 64-64 64zm64-208l-128 0 0-80 128 0 0 80zm0-128l-128 0 0-80 128 0 0 80zM112 424a24 24 0 1 0 0-48 24 24 0 1 0 0 48z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSwatchbook = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;